export default __webpack_public_path__ + "static/media/outcess23.794e0217.jpeg";